<template>
  <div class="main-dashboard-panel">
    <div class="panel-topnav container-fluid">
      <a href="" class="hidden back-link pull-left">
        <i class="ion-ios-arrow-back text-yellow before"></i> Projects
      </a>
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Dashboard
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <OrganizationDashboard v-if="user.isOrganizer" :org-id="org.id" />
    <StartupEdit v-if="user.isStartup" />

    <div class="container-fluid hidden">
      <div class="row">
        <div class="col-sm-12 pane">
          foo
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 pane">
          bar
        </div>
        <div class="col-md-6 pane">
          bar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationEdit from '@/modules/organizations/OrganizationEdit'
import OrganizationDashboard from '@/modules/organizations/OrganizationDashboard'
import StartupEdit from '@/modules/dashboard-startup/StartupEdit'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: { OrganizationDashboard, StartupEdit },
  computed: mapState({
    user: (state) => state.user.data,
    org: (state) => {
      const org = _.first(state.user.data.organizations)
      if (org) {
        return org
      } else {
        return {}
      }
    },
  }),
}
</script>
